import { useAtom } from "@reatom/npm-react";
import { useCallback } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { productDetailModalAtom, selectedProductAtom } from "src/store/atoms";

import { ProductModal, ProductSheet } from "./components";
import { useProductDetail } from "./hooks";

export const ResponsiveProductDetailWidget = () => {
  const { isMobile } = useGravityDevice();

  const [isOpen, setIsOpen] = useAtom(productDetailModalAtom);
  const [spuId] = useAtom(selectedProductAtom);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const { product, isLoading, hasMoney, hasSubscribe } = useProductDetail(
    isOpen ? Number(spuId) : 0,
  );

  if (isMobile) {
    return (
      <ProductSheet
        open={isOpen}
        onClose={onClose}
        spuId={spuId}
        product={product}
        isLoading={isLoading}
        hasMoney={hasMoney}
        hasSubscribe={hasSubscribe}
      />
    );
  }
  return (
    <ProductModal
      open={isOpen}
      onClose={onClose}
      product={product}
      isLoading={isLoading}
      hasMoney={hasMoney}
      hasSubscribe={hasSubscribe}
    />
  );
};
